export enum EModeEstimationRecouvrement {
    Facies = 1,
    Bandes = 2,
    Quadrats = 3
}